import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const Header = styled.div`
    h1, h2, h3, h4, h5, h6 {
        font-family: ${props => props.theme.font_subheader};
        font-weight: ${props => props.theme.font_weight_bold};
        line-height: 1em;
        margin: 0 0 calc(${props => props.theme.element_margin} * 0.5) 0;
        color: ${props => props.inverse
        ? props.theme.font_light
        : props.accent
            ? props.theme.accent
            : props.theme.font_dark
    };
        a {
            color: inherit;
            text-decoration: none;
        }
        .accent {
            color: ${props => props.theme.color_accent};   
        }
    }
    h1 {
        font-family: ${props => props.theme.font_header};        
        font-size: 2.25em;
        line-height: 1.35em;
    }

    h2 {
        
        font-size: 2em;
        line-height: 1.35em;
    }

    h3 {

        font-size: 1.35em;
        line-height: 1.5em;
    }

    h4 {
 
        font-size: 1.25em;
        line-height: 1.5em;
    }

    h5 {

        font-size: 0.9em;
        line-height: 1.5em;
    }

    h6 {

        font-size: 0.9em;
        line-height: 2.3em;
    }
    @media (max-width: 736px){
        h1 {
            font-size: 1.8em;
        }

        h2 {
            font-size: 1.4em;
        }

        h3 {
            font-size: 1.2em;
        }

        h4 {
            font-size: 1em;
        }
    }
`
const MajorHeader = Header.extend`
    h1 {
        font-family: ${props => props.theme.font_header};        
        font-size: 3.5em;
        line-height: 1.35em;
    }
    @media (max-width: 736px){
        h1 {
            font-size: 2.8em;
        }
    }
    @media (max-width: 468px){
        h1 {
            font-size: 1.8em;
        }
    }
`
const AbsoluteHeader = Header.extend`
    z-index: -1;
    position: absolute;
    margin: auto;
    top: 25;
    left: 10;
    @media screen and (min-width: 1280px){
        top: 35%;
        left: 45%;
        transform: translate(-50%, -50%);
    }
`
const Accent = styled.span`
    color: ${props => props.theme.accent};
`
export { Header, MajorHeader, AbsoluteHeader, Accent }



// WEBPACK FOOTER //
// ./src/components/header.js